export default __webpack_public_path__ + "static/LeituraDisplayTwo-Italic-7522b6dddee90aaa2031118804429835.woff2";